import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

interface ContractTypeData {
    type: string;
    count: number;
    percentage: number;
}

const contractTypeData: ContractTypeData[] = [
    { type: 'CLT', count: 124, percentage: 58.2 },
    { type: 'PJ', count: 67, percentage: 31.5 },
    { type: 'Estágio', count: 18, percentage: 8.5 },
    { type: 'Freelancer', count: 4, percentage: 1.8 },
];

// Cores seguindo padrão do projeto
const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444'];

const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
        const data = payload[0].payload;
        return (
            <div className="bg-white p-3 border border-gray-200 rounded-lg shadow-lg">
                <p className="font-medium text-gray-900">{data.type}</p>
                <p className="text-sm text-gray-600">
                    {data.count} colaboradores ({data.percentage}%)
                </p>
            </div>
        );
    }
    return null;
};

export default function ContractTypeDistribution() {
    const totalCollaborators = contractTypeData.reduce((sum, item) => sum + item.count, 0);

    return (
        <div className="bg-white rounded-lg shadow p-4">
            {/* Header */}
            <div className="mb-4">
                <h3 className="text-base font-semibold text-gray-900 mb-1">
                    Colaboradores por Tipo de Contrato
                </h3>
                <p className="text-xs text-gray-600">
                    Distribuição dos {totalCollaborators} colaboradores ativos
                </p>
            </div>

            {/* Chart */}
            <div className="h-48">
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={contractTypeData}
                            cx="50%"
                            cy="50%"
                            labelLine={false}
                            outerRadius={70}
                            fill="#8884d8"
                            dataKey="count"
                            stroke="#ffffff"
                            strokeWidth={2}
                        >
                            {contractTypeData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip content={<CustomTooltip />} />
                    </PieChart>
                </ResponsiveContainer>
            </div>

            {/* Stats Summary */}
            <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-3 pt-3 border-t border-gray-200">
                {contractTypeData.map((item, index) => (
                    <div key={item.type} className="text-center">
                        <div className="flex items-center justify-center mb-1">
                            <div
                                className="w-2 h-2 rounded-full mr-1"
                                style={{ backgroundColor: COLORS[index] }}
                            />
                            <span className="text-xs font-medium text-gray-700">{item.type}</span>
                        </div>
                        <div className="text-lg font-bold text-gray-900">{item.count}</div>
                        <div className="text-xs text-gray-500">{item.percentage}%</div>
                    </div>
                ))}
            </div>
        </div>
    );
} 